import { LayoutType, withLayout } from 'hocs/with-layout';
import { SelfRecordingGuest } from './self-recording-guest';

const WrappedAccountView = withLayout(
  LayoutType.WithNavOnly,
  SelfRecordingGuest,
);

export { WrappedAccountView as SelfRecordingGuest };
